<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";

/**
 * Invoice-detail component
 */
export default {
    components: { ErrorMessage,Layout, PageHeader },
    data() {
        return {
            errorMessage: "",
            title: "Booking Details",
            items: [
                {
                    text: "Booking",
                    href: "/"
                },
                {
                    text: "Details",
                    active: true
                }
            ],
            errors: null,
            bookingId:"",
            agent:"",
            passengers:[],
            tickets:[],
            booking:"",
            status:"",
            visible:false,
            message:"",
            print:true,
        };
    },
    created() {
        this.bookingId = this.$route.params.id;
    },
    mounted() {
        this.getBookingDetail();
    },
    updated: function () {
        if(this.print){
            window.print();
        }
        // this.$nextTick(function () {
        //     window.print();
        // })
    },
    methods: {
        onClose(){
            this.visible=false;
        },
        sendMail(id) {

            try {
                axios
                    .post("/api/flight-booking-details-mail/" + id, {
                        accessToken: localStorage.getItem("access_tocken"),
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.$swal("Mail Sent Successfully");
                            // this.passengers=response.data.data.passengers;
                            // this.booking=response.data.data.booking;
                            // this.status=response.data.data.status;
                            // this.tickets=response.data.data.tickets;
                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
        async getBookingDetail() {
            try {
                axios
                    .post("/api/flight-booking/details/" + this.bookingId, {
                        accessToken: localStorage.getItem("access_tocken"),
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.booking=response.data.data;
                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
        errorCheck(obj) {
            this.print=false;
            if(obj.statusCode == 403){
                this.visible=true;
                this.message="Access Permission Denied";
                this.errors = obj.message;
            }else if (obj.error) {
                this.errors = obj.message;
            } else if (obj.message == "Token has expired") {
                this.$swal.fire({
                    title: 'LogOut!',
                    text: 'Token Has Expired',
                    icon: 'error',
                    toast:'true',
                    position: 'top-end',
                });
                this.$router.push({ name: "logout" });
            } else if (
                obj.message !== "Token has expired" &&
                obj.message !== "The given data was invalid."
            ) {
                this.errors = obj.message;
            } else if (obj.message == "The given data was invalid.") {
                this.errors = obj.errors;
            } else {
                this.flashMessage.show({
                    time: 5000,
                    status: "error",
                    title: "Error",
                    message: "Problem in data save",
                });
            }
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <h4>Booking Info</h4>
                        <div class="table-responsive table-bordered table-sm">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>Key</th>
                                    <th> Status</th>
                                    <th>
                                        <div>Api/</div>
                                        <div>Airline Pnr</div>
                                    </th>
                                    <th>Base Fare</th>
                                    <th>Total Tax</th>
                                    <th>Gross Fare</th>
                                    <th>Ait</th>
                                    <th>Markup</th>
                                    <th>Commission</th>
                                    <th>Invoice Fare</th>
                                    <th>Currency</th>
                                    <th>Airline</th>
                                    <th>Trip Type</th>
                                    <th>Payment Status</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>{{booking.search_reference_key}}</td>
                                    <td>{{booking.booking_status_name}}</td>
                                    <td>
                                        <div>{{booking.api_pnr}}</div>
                                        <div>{{booking.airline_pnr}}</div>
                                        </td>
                                    <td>{{booking.base_fare}}</td>
                                    <td>{{booking.total_tax}}</td>
                                    <td>{{booking.gross_fare}}</td>
                                    <td>{{booking.ait}}</td>
                                    <td>{{booking.markup}}</td>
                                    <td>{{booking.commission}}</td>
                                    <td>{{booking.invoice_fare}}</td>
                                    <td>{{booking.currency}}</td>
                                    <td>{{booking.airline}}</td>
                                    <td>{{booking.trip_type}}</td>
                                    <td>{{booking.payment_status}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                            <h4>Flight Info</h4>
                            <div class="table-responsive table-bordered table-sm">
                                <table class="table mb-0">
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Origin</th>
                                        <th>Departure Time</th>
                                        <th>Origin Terminal</th>
                                        <th>Destination</th>
                                        <th>Arrival Time</th>
                                        <th>Destination Terminal</th>
                                        <th>Baggage Info</th>
                                        <th>Fare Basis</th>
                                        <th>Airline</th>
                                        <th>Flight Number</th>
                                        <th>Travel Duration</th>
                                        <th>Booking Class</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(flight,index) in booking.flight_segments"  v-bind:key="index">
                                        <th>{{index+1}}</th>
                                        <td>{{flight.origin_code}}</td>
                                        <td>{{flight.arrival_date |  moment('LLL')}}</td>
                                        <td>{{flight.origin_terminal==null ? 'N/A' : flight.origin_terminal}}</td>
                                        <td>{{flight.destination_code}}</td>
                                        <td>{{flight.destination_date |  moment('LLL')}}</td>
                                        <td>{{flight.destination_terminal==null ?  'N/A' : flight.destination_terminal}}</td>
                                        <td>{{flight.baggage_information==null ? 'N/A' : flight.baggage_information }}</td>
                                        <td>{{flight.fare_basis==null ? 'N/A' : flight.fare_basis}}</td>
                                        <td>{{flight.operating_airline_code==null ? 'N/A' : flight.operating_airline_code}}</td>
                                        <td>{{flight.operating_flight_number==null ? 'N/A' : flight.operating_flight_number}}</td>
                                        <td>{{flight.travel_duration==null ? 'N/A' : flight.travel_duration }}</td>
                                        <td>{{flight.booking_class}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <br>

                        <div>
                            <h4>Passenger Info</h4>
                            <div class="table-responsive table-bordered table-sm">
                                <table class="table mb-0">
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Passenger Name</th>
                                        <th>Birth Date</th>
                                        <th>Passport No.</th>
                                        <th>Passport Expiry</th>
                                        <th>Passport Issue Country</th>
<!--                                        <th>Passenger Type</th>-->
                                        <th>
                                            <div>
                                                Gender/
                                            </div>
                                            <div>
                                                Nationality
                                            </div>
                                        </th>
<!--                                        <th></th>-->
                                        <th>Base Fare</th>
                                        <th>Total Tax</th>
                                        <th>Gross Fare</th>
                                        <th>Ait</th>
                                        <th>Markup</th>
                                        <th>Commission</th>
                                        <th>Invoice Fare</th>
                                        <th>Ticket No.</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(passenger,index) in booking.flight_passengers" v-bind:key="index">
                                        <th>{{index+1}}</th>
                                        <td>
                                            <div>
                                                {{passenger.prefix}} {{passenger.first_name}} {{passenger.last_name}}
                                            </div>
                                            <div>
                                                {{passenger.passenger_type}}
                                            </div>
                                        </td>
                                        <td>{{passenger.date_of_birth |  moment('ll')}}</td>
                                        <td>{{passenger.passport_no==null ? 'N/A' : passenger.passport_no}}</td>
                                        <td>{{passenger.passport_expiry_date==null ? 'N/A' : passenger.passport_expiry_date|  moment('ll')}}</td>
                                        <td>{{passenger.passport_issue_country==null ? 'N/A' : passenger.passport_issue_country}}</td>
<!--                                        <td>{{passenger.passenger_type}}</td>-->
                                        <td>
                                            <div>
                                                {{passenger.gender}}
                                            </div>
                                            <div>
                                                {{passenger.nationality}}
                                            </div>
                                            </td>
<!--                                        <td></td>-->
                                        <td>{{passenger.base_fare}}</td>
                                        <td>{{passenger.total_tax}}</td>
                                        <td>{{passenger.gross_fare}}</td>
                                        <td>{{passenger.ait}}</td>
                                        <td>{{passenger.markup}}</td>
                                        <td>{{passenger.commission}}</td>
                                        <td>{{passenger.invoice_fare}}</td>
                                        <td>{{passenger.flight_ticket==null ? 'N/A' : passenger.flight_ticket.ticket_no}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="d-print-none">
                            <div class="float-right">
                                <a href="javascript:window.print()" class="btn btn-success">
                                    <i class="fa fa-print"></i>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>

<!--<style scoped>-->
<!--tr>td{-->
<!--    width:35%;-->
<!--    height:30px;-->
<!--}-->
<!--.padding-2percent{-->
<!--    padding-top: 2%;-->
<!--}-->
<!--</style>-->

<style scoped>
/*tr>td{*/
/*    width:35%;*/
/*    height:30px;*/
/*}*/
/*.padding-2percent{*/
/*    padding-top: 2%;*/
/*}*/
/*table*/
/*{*/
/*    table-layout: fixed;*/
/*    width: 1100px;*/
/*}*/
</style>
